module.exports = __webpack_public_path__ + "static/img/help12.ed90013f.png";